import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const link: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M13.2676,10.9395 L12.5606,10.2315 C11.3936,9.0655 9.4846,9.0655 8.3176,10.2315 L4.0756,14.4745
        C2.9086,15.6415 2.9086,17.5505 4.0756,18.7175 L4.7826,19.4245 C5.9496,20.5905 7.8586,20.5905
        9.0246,19.4245 L11.5046,16.9445 M9.7324,13.0605 L10.4394,13.7675 C11.6064,14.9345 13.5154,14.9345
        14.6814,13.7675 L18.9244,9.5245 C20.0914,8.3585 20.0914,6.4495 18.9244,5.2825 L18.2174,4.5755
        C17.0504,3.4085 15.1414,3.4085 13.9744,4.5755 L11.5004,7.0505"
      ></path>
    </svg>
  );
};
